import { Component } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { ConfiguracoesService } from './sistema/commons/services/configuracoes/services/configuracoes.service';

@Component({
	selector: 'aml-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent {
	title = 'Avaliação de Efetividade';

	constructor(
		private config: PrimeNGConfig,
		private configuracoesService: ConfiguracoesService
	) {
		this.config.setTranslation(
			this.configuracoesService.getCalendarLocale()
		);
	}
}
